import React, {useEffect, useState} from 'react';
import {Button, Toggle} from '../../../../components';
import TreeEPCForm from "../../../../components/Layout-Components/Editor-Layout/TreeEPC/TreeEPCForm";
import {useViewerStore} from "../../../../store/store";
import {GetRoundNum} from "../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/Common";
import {Flex, Select, Tooltip} from 'antd';
import {BiReset} from "react-icons/bi";
import { RoofIdealMultiplier, RoofMesh } from '../../../../@types/types';

const CalculationProperties: React.FC = () => {

    const sceneViewer = useViewerStore(state => state.sceneViewer);
    const layerVisibilityState =  useViewerStore(state => state.layerVisibilityState);

    const isTreeMultiplierLabelVisible = useViewerStore((state) => state.isTreeMultiplierLabelVisible)
    const isTreeLabelVisible = useViewerStore(state => state.isTreeLabelVisible);
    const isModuleLabelVisible = useViewerStore(state => state.isModuleMultiplierLabelVisible);
    const localAngIdeal = useViewerStore(state => state.savedRoofWiseIdealMultiplier);
    const roofInfoArr = useViewerStore(state => state.roofInfoArr);

    const [roofMultipliers, setRoofMultipliers] = useState<RoofIdealMultiplier[]>([]);
    const [isIdealMultiplierVisible, setIsIdealMultiplierVisible] = useState(false);


    const escalatorOptions = [
        {label: 'Select an Escalator...', value: null},
        {label: '0.0', value: 0.0},
        {label: '0.9', value: 0.9},
        {label: '1.9', value: 1.9},
        {label: '2.9', value: 2.9}
    ];

    const isEscalatorSelected = useViewerStore(state => state.isEscalatorSelected);

    const handleEscalatorChange = (newValue: number) => {
        useViewerStore.setState({escalatorValue: newValue, isEscalatorSelected: true});
    }

    const resetEscalatorSelection = () => {
        useViewerStore.setState({escalatorValue: undefined , isEscalatorSelected: false});
    }

    const toggleIdealMultiplier = () => {
        setIsIdealMultiplierVisible(!isIdealMultiplierVisible);
    }

    const toggleTreeMultiplierVisibility = () => {
        sceneViewer.toggleTreeMultiplierLabel(!isTreeMultiplierLabelVisible);
        useViewerStore.setState({isTreeMultiplierLabelVisible: !isTreeMultiplierLabelVisible});
    }

    const toggleTreeNameLabel = () => {
        useViewerStore.setState({isTreeLabelVisible: !isTreeLabelVisible})
        sceneViewer.toggleTreeLabel();
    }

    const toggleModuleMultiplier = () => {
        if (!isModuleLabelVisible) {
            sceneViewer.moveCameraToSiteMidpointView();
            sceneViewer.camera.zoom = 40;
            sceneViewer.camera.updateProjectionMatrix();
        }
        useViewerStore.setState({isModuleMultiplierLabelVisible: !isModuleLabelVisible})
        sceneViewer.toggleModuleMultiplierLabel(!isModuleLabelVisible);
    }

    useEffect(() => {
        const roofs = sceneViewer.roofs[0].faces;
        console.log('roofs', roofs);
        let ideal: RoofIdealMultiplier[] = [];
        roofs.forEach((roof: RoofMesh) => {
            console.log('roof', roof);
            console.log('ideal', localAngIdeal);
            console.log('roofInfoArr', roofInfoArr);
            const roofIdeal = localAngIdeal.find(item => item.tilt === roof.oriAng.tilt)?.ideal ?? 0;
            const roofMultiplier = roofInfoArr.find(item => item.roofFaceId === roof.roofFaceId)?.roofMultiplier;
            const roofNum = roofInfoArr.find(item => item.roofFaceId === roof.roofFaceId)?.roofNum;
            if (!roofMultiplier || !roofNum) {
                console.log('Missing roofMultiplier or roofNum for roofFaceId:', roof.roofFaceId);
                return};

            ideal.push({
                roofNo: roofNum,
                roofIdeal: GetRoundNum(roofIdeal, 16),
                roofMultiplier: roofMultiplier ? roofMultiplier : 0
            });
            setRoofMultipliers(ideal);
        });
    }, [roofInfoArr]);

    return (
        <>
            <div className="tab__inner">
                <div className="tab__title">
                    <span className="tab__title--text tab__title--flex">
                        EPC Calculation
                    </span>
                    <Tooltip title="Reset Escalator">
                        <div>
                           <Button
                                onClick={resetEscalatorSelection}
                                variant="btn-clear"
                                size="btn-resize"
                            >
                                <BiReset size={24}/>
                            </Button>  
                        </div>
                       
                    </Tooltip>
                    
                </div>

                {/* Show EscalatorSelection before showing EPC Tool */}
                {!isEscalatorSelected &&
                <div className="tab__inner" style={{paddingTop: '10px'}}>
                    <div className='tab__flex' style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <span className="tab__column--subtitle mb-1">Select Escalator</span>
                    </div>
                    <Flex align="center" wrap="wrap" justify='center' align-items='center' gap={20} style={{paddingLeft:'20px', paddingRight: '20px'}}>
                        {window.innerWidth >= 1366 ? /* Check if device is iPad or PC */
                            <Select /* PC version displays a dropdown with all escalator options */
                                placeholder="Select an Escalator..."
                                id="escalatorOptionsSelect"
                                options={escalatorOptions}
                                value={escalatorOptions[0].value}
                                onChange={(value) => handleEscalatorChange(value)}
                            />
                            : /* iPad version displays individual buttons for each escalator option */
                            <> {escalatorOptions.slice(1, escalatorOptions.length).map((option) => (
                                <Button 
                                    key={option.value}
                                    id={`${option.label}-escalator-option`}
                                    variant="btn-primary"
                                    onClick={() => handleEscalatorChange(option.value ?? 0)}>
                                    <button style={{width: "100px", backgroundColor: "transparent", color: "white", cursor: "pointer"}}
                                        > {option.label}
                                    </button>
                                </Button>
                                
                            ))}
                            </>
                        }
                    </Flex>
                </div>
                }
                <br/>

                {/*EPC TOOL, Only display if an escalator was selected */}
                {isEscalatorSelected && <TreeEPCForm/>}

                <br/>

                {/* MULTIPLIERS - IDEAL, TREE and MODULES */}
                <div className='tab__column'>
                    <div className='tab__flex justify-between mb-2'>
                        <span className='tab__column--subtitle mb-0'>Show Ideal Multipliers</span>
                        <Toggle
                            onChange={toggleIdealMultiplier}
                            on={isIdealMultiplierVisible}
                        />
                    </div>
                    {isIdealMultiplierVisible && <div>
                        <span className='tab__column--subtitle mb-1'>Multipliers</span>
                        <div style={{maxHeight: '290px', overflow: 'auto'}}>
                            <table className={"tab__table"}>
                                <thead>
                                <tr
                                    style={{
                                        position: 'sticky',
                                        top: '0',
                                    }}
                                >
                                    <th>Roof No</th>
                                    <th>Ideal</th>
                                    <th>Roof Avg.</th>
                                </tr>
                                </thead>
                                <tbody>
                                {roofMultipliers.map((ideal, i) => {
                                    return (
                                        <tr key={i}>
                                            <td>{ideal.roofNo}</td>
                                            <td>{GetRoundNum(ideal.roofIdeal, 6)}</td>
                                            <td>{GetRoundNum(ideal.roofMultiplier, 6)}</td>
                                        </tr>
                                    )
                                })}
                                </tbody>
                            </table>
                        </div>
                        <br/>
                    </div>}
                    <div className='tab__flex justify-between mb-2'>
                        <span className='tab__column--subtitle mb-0'>Show Tree Multiplier</span>
                        <Toggle
                            onChange={toggleTreeMultiplierVisibility}
                            property='TreeMultiplier'
                            on={isTreeMultiplierLabelVisible}
                            disabled={!layerVisibilityState.tree}
                        />
                    </div>
                    <div className='tab__flex justify-between mb-2'>
                        <span className='tab__column--subtitle mb-0'>Show Tree Label</span>
                        <Toggle
                            on={isTreeLabelVisible}
                            onChange={toggleTreeNameLabel}
                            property='treeNameLabel'
                            disabled={!layerVisibilityState.tree}
                        />
                    </div>
                    <div className='tab__flex justify-between mb-2'>
                        <span className='tab__column--subtitle mb-0'>Show Module Multiplier</span>
                        <Toggle
                            onChange={toggleModuleMultiplier}
                            on={isModuleLabelVisible}
                            disabled={!layerVisibilityState.modules || !layerVisibilityState.roof}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default CalculationProperties;